<script lang="ts">
  // components
  import { TaskPanel } from "@getprovi/craft-svelte";
  import { get } from "svelte/store";
  import { createEventDispatcher, onDestroy } from "svelte";
  import { VT_802_SPIRITS_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";
  import Connect from "@retailer/svelte/ControlStateUserAuthentication/Vermont/VermontConnect.svelte";
  import Success from "@retailer/svelte/ControlStateUserAuthentication/Vermont/VermontSuccess.svelte";

  // stores
  import RetailerUserAuthenticationsStore from "@retailer/svelte/stores/RetailerUserAuthenticationsStore";
  import RetailerUserAuthenticationModalStore from "@retailer/svelte/stores/RetailerUserAuthenticationModalStore";
  import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";

  // services
  import { getRetailerUserAuthenticationStatus } from "@shared/services/retailer_user_authentication_service";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { RetailerUserAuthenticationEventEntity } from "@shared/services/event_tracking/entities/retailer_user_authentication_event_entity";

  export let open: boolean = false;
  export let distributorId: number = null;

  const dispatch = createEventDispatcher();

  let authStatus: string;

  const unsubscribe = RetailerUserAuthenticationModalStore.subscribe(n => {
    open = n.open;
    distributorId = n.distributorId;
    if (!distributorId) {
      let distributorIds = get(DistributorsStore)
        .filter(d => d.require_retailer_user_authentication)
        .map(d => d.id);
      distributorId = distributorIds[0] || VT_802_SPIRITS_DISTRIBUTOR_ID;
    }
  });

  onDestroy(() => {
    unsubscribe();
  });

  function currentStep() {
    if (authStatus == "valid") {
      return "success";
    } else {
      return "intro";
    }
  }

  function closeModal() {
    open = false;
    let distributors = get(DistributorsStore);
    authStatus = getRetailerUserAuthenticationStatus($RetailerUserAuthenticationsStore, [
      distributors.find(d => d.id == distributorId),
    ]);
    RetailerUserAuthenticationModalStore.set({ open: false, distributorId: null });

    let entity = new RetailerUserAuthenticationEventEntity({
      distributorId: distributorId,
      step: currentStep(),
      authenticationStatus: authStatus,
    });
    EventTracking.trackClick("retailer_user_authentication_close_authentication_flow", [entity]);

    dispatch("close");
  }

  function findTitle(status: string): string {
    switch (status) {
      case "valid":
        return "Account Authenticated";
      default:
        return "Authenticate Account";
    }
  }

  $: {
    let distributors = get(DistributorsStore);
    authStatus = getRetailerUserAuthenticationStatus($RetailerUserAuthenticationsStore, [
      distributorId,
    ]);

    if (authStatus == "invalid") {
      open = false;
    }
  }

  $: title = findTitle(authStatus);
</script>

<div class="craft fizz-styles">
  <TaskPanel
    bind:open
    clickOutsideCallback={closeModal}
    closeBtnClick={closeModal}
    id="vermont-auth-task-panel"
    variant="minimal"
    testId="vermont-auth-task-panel"
    {title}
  >
    {#if authStatus == "pending"}
      <Connect {distributorId} />
    {:else if authStatus == "valid"}
      <Success />
    {/if}
  </TaskPanel>
</div>
